export default __webpack_public_path__ + "static/media/3031 knife block C top.ca5ed0bc.png";